define('shared/initializer/form/newHouseAdapters/util/ValueCollectorForDataDispatcher',['shared/lib/RSVP'], function(RSVP){
    function Ctor(payload) {
        var me = this;
        me.collect = function(key, value) {
            var keys = key.split('.');
            var container = payload;
            for(var i = 0; i < keys.length - 1; i++) {
                if (!container[keys[i]]) {
                    container[keys[i]] = {};
                } 
                container = container[keys[i]];
            }
            container[keys[keys.length - 1]] = value;
            return RSVP.resolve();
        };
    }

    return Ctor;
});
